<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter"><em>Acknowledgments</em></h1>
<p class="nonindent"><em>With special thanks to my husband Colin, my knight in shining armour, who always knew that I would be published one day, with inspiration, support and love also provided by my daughter Deborah who was my proof-reader, her partner Adrian, my son James, my daughter-in-law Angela, my lovely grandson Luke James and my family for whom many of these verses were written. These verses owe much to those who I have loved and lost at an early age but moreover to those who have been exceptional friends throughout my life such as Ethel Houghton, Deborah Forrest, Su Marshall, Barbara and Keith Milton and so many more who know who they are. Friendship is such a precious gift from God and He has certainly bestowed on me some of the most treasured moments and memories from true angels here on earth, my thanks to God and all of them from the bottom of my heart, these words are for you.</em><br/></p>
<p class="extract"><strong>Every good and perfect gift is from above,</strong> <em>James 1:17</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?395e1425